import { gql } from "@apollo/client";

export const APPLY_EXCEPTION_REVIEW = gql`
  mutation ApplyExceptionReview($input: ExceptionReviewInput!) {
    applyExceptionReview(input: $input)
  }
`;
